// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_foundation.js'; import './autoload/_svgConvert.js'

// Import Slick
import 'slick-carousel/slick/slick';
import './autoload/_svgConvert';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js